import React, {useEffect, useState} from "react";
import {useMediaQuery, useTheme} from "@mui/material";


/**
 * The context provide media data for the whole application
 * such as window width, height, etc.
 */

const MediaContext = React.createContext({});

export const MediaContextProvider = ({children}) => {
    const theme = useTheme();
    const isUnderSm = useMediaQuery(theme.breakpoints.down("sm"));
    const isUnderMd = useMediaQuery(theme.breakpoints.down("md"));
    const isUnderLg = useMediaQuery(theme.breakpoints.down("lg"));
    const isUnderXl = useMediaQuery(theme.breakpoints.down("xl"));

    /**
     * When isMobileSize is true, the app should not be wrapped in a <Container>
     * thereby allowing the app to take up the full width of the screen.
     * We also switch to the mobile top-bar at this point.
     */
    const mobileSize = useMediaQuery(`(max-width:900px)`);

    /** `useMediaQuery('(pointer: coarse)')` returns true if the primary input
     * is coarse (e.g., touch). On most desktop computers with touchscreens,
     * the primary input method is typically a mouse or trackpad, in which cases,
     * the query will return false.
     */
    const isTouchInput = useMediaQuery(`(pointer: coarse)`);

    return <MediaContext.Provider
        value={{
            isUnderSm: isUnderSm,
            isUnderMd: isUnderMd,
            isUnderLg: isUnderLg,
            isUnderXl: isUnderXl,
            isMobileSize: mobileSize,
            isTouchInput: isTouchInput,
        }}>
        {children}
    </MediaContext.Provider>
}

export const useMediaContext = () => {
    return React.useContext(MediaContext);
}

// Renders only on desktop
export const DesktopView = ({children}) => {
    const mediaContext = useMediaContext();

    if (mediaContext.isMobileSize) return null;
    return <React.Fragment>{children}</React.Fragment>;
}

// Renders only on mobile
export const MobileView = ({children}) => {
    const mediaContext = useMediaContext();

    if (!mediaContext.isMobileSize) return null;
    return <React.Fragment>{children}</React.Fragment>;
}


